/**
 * The window a survey chart strip opens on: **eight weeks, ending today.**
 *
 * Thirty days is four columns at a weekly cadence — too few for a trend. Eight weeks is the canon's
 * own specimen (`ankiety-klienta-2026-09-16`, `01-matryca.html` draws eight columns) and two months
 * of a weekly check-in. Stated once, here: the client's Ankiety tab opens its range bar on it and
 * the review inbox on `/raporty` draws the same strip over the same span.
 *
 * The arithmetic is UTC throughout, so a civil date never drifts by a zone.
 *
 * Pure: no React, no DOM, no query hook, no i18next.
 */

import { MS_PER_DAY, toIsoDate } from '~/shared/lib/calendarDate';

const SURVEY_CHART_WINDOW_DAYS = 56;

export interface SurveyChartWindow {
  /** `YYYY-MM-DD`. */
  readonly from: string;
  /** `YYYY-MM-DD`. */
  readonly to: string;
}

export function surveyChartWindow(today: Date): SurveyChartWindow {
  const to = toIsoDate(today);
  const from = new Date(Date.parse(`${to}T00:00:00Z`) - SURVEY_CHART_WINDOW_DAYS * MS_PER_DAY)
    .toISOString()
    .slice(0, 10);
  return { from, to };
}
